import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DataTable from "../../Templets/DataTable/DataTable";
import Reactportal from "../Reactportal/Reactportal";
import { useModalContext } from "../Reactportal/ModalContext";
import PortalFooter from "../Reactportal/PortalFooter";

const BranchesSection = ({
  getSelectedBranches,
  getDataQueryByID,
  Id,
  fielddata,
  selectedRows,
  closeBranchesSection,
  show,
  TypeOfPortal,
}) => {
  const Form_Key = "Select_Vehicle_data";
  const { pushModal, popModal, } = useModalContext();
  const [vehicleCategoryData, setVehicleCategoryData] = useState();
  const FormData = useSelector((store) => store.FormFieldData);
  const { data: GetBranchData } = useQuery(getDataQueryByID, {
    variables: { keyword: "", Common_Id: Id },
    fetchPolicy: "cache-and-network",
  });

  const [toggle, setToggle] = useState(show);
  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    if (GetBranchData && Object.values(GetBranchData)[0]) {
      setVehicleCategoryData(GetBranchData && Object.values(GetBranchData)[0].map(({ __typename, ...rest }) => rest));
    }
    // }
  }, [GetBranchData]);

  const Closeformfunction1 = () => {
    let key = Id;
    getSelectedBranches({
      ...selectedRows,
      [key]: FormData.MultiSelectedRows[key],
    });
    closeBranchesSection();
  };
  const footerContent = (
    <PortalFooter
      submitType={""}
      handleformclose={Closeformfunction1}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
    />
  );
  return (
    <>
      {
        <div>
          <Reactportal
            open={toggle}
            onClose={Closeformfunction1}
            FoooterContent={footerContent}
            TypeOfPortal={TypeOfPortal}
          >
            <div className="BranchData">
              {!vehicleCategoryData?.length ? (
                <p>Data not Avaliable</p>
              ) : (
                <DataTable
                  ledger=""
                  title={`${Id} New Branches`}
                  formdata={vehicleCategoryData && vehicleCategoryData}
                  loading={false}
                  error={false}
                  length={vehicleCategoryData?.length}
                  crSum={0}
                  drSum={0}
                  roletable={false}
                  selectedRows={selectedRows && selectedRows[Id]}
                />
              )}
            </div>
            {/* <div className="BranchesFooter">
              <Button action={Closeformfunction1} text={"Close"} name={"BranchButton"} />
            </div> */}
          </Reactportal>
        </div>
      }
    </>
  );
};

export default BranchesSection;
